import authRouter from '@/modules/auth/router'
import dashboardRouter from '@/modules/dashboard/router'
import { isAuthenticatedGuard, isNotAuthenticatedGuard } from './guard'

const routes = [
  {
    path: '/',
    redirect: '/auth/login'
  },

  {
    path: '/auth',
    beforeEnter: isNotAuthenticatedGuard,
    ...authRouter,
  },

  {
    path: '/dashboard',
    beforeEnter: isAuthenticatedGuard,
    ...dashboardRouter,
  },

  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue')
  }
]

export default routes
